import { combineReducers, applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { type PlatformApi } from '@app/external/common/controller/platform-api';
import { type AppStore, type ControllerConfig, type FlowAPI } from '@app/external/common/types';
import { createMessageMiddleware } from '../../common/messages/framework/initialize-store';
import { postMetadataMiddleware } from '../../common/middleware/post-metadata-middleware';
import { createModalOpenedMiddleware } from '../../common/modals/framework/initialize-store';
import commonReducers from '../../common/reducers';
import postCount from '../../common/store/post-count/post-count-reducer';
import messageResolvers from '../containers/messages/message-resolvers';
import { modalDataLoaderByType } from '../containers/modals/modal-data-loader-map-by-type';
import activeTab from '../store/active-tab/active-tab-reducer';
import viewedUser from '../store/viewed-user/viewed-user-reducer';
import { type MyPostsWidgetThunkArgs } from '../types';

export function createReduxStore({
  appParams,
  platformApi,
  compId,
  isSSR,
  language,
  flowAPI,
}: {
  appParams: ControllerConfig['appParams'];
  platformApi: PlatformApi;
  compId: ControllerConfig['compId'];
  isSSR: boolean;
  language: string;
  bundleName: string;
  flowAPI: FlowAPI;
}) {
  const middleware = [
    thunk.withExtraArgument({
      platformApi,
      compId,
      appParams,
      panoramaClient: flowAPI.panoramaClient,
      httpClient: flowAPI.httpClient,
      errorHandler: flowAPI.errorHandler,
    } satisfies MyPostsWidgetThunkArgs),
    postMetadataMiddleware({ isSSR, language, localizePosts: true }),
    createModalOpenedMiddleware({ modalDataLoaderByType }),
    createMessageMiddleware({ resolvers: messageResolvers }),
  ];

  const reducers = combineReducers({
    ...commonReducers,
    postCount,
    viewedUser,
    activeTab,
  });

  const initialState = { experiments: flowAPI.essentials.experiments.all() };

  return createStore(reducers, initialState, applyMiddleware(...middleware)) as unknown as AppStore;
}
